<template>
  <div class="ma-6">
     <h4>Branch : {{branch}}</h4>
     <h4>Commit Hash : {{commitHash}}</h4>
     <h4>Commit Date : {{commitDate}}</h4>
     <h4>Crane Pricer Version : {{versionDetails.version}}</h4>
  </div>
</template>
<script>
const branch = import.meta.env.VITE_GIT_BRANCH_NAME;
const commitHash = import.meta.env.VITE_GIT_COMMIT_HASH;
const commitDate = import.meta.env.VITE_GIT_COMMIT_DATE;
import { versionDetails } from "crane-pricer";

export default {
  name: "BuildVersion",
  data: () => ({
    branch:branch,
    commitHash:commitHash,
    commitDate:commitDate,
    versionDetails:versionDetails
  }),

};
</script>
